export enum PROGRAMMABLE_SORT_INFO {
  PROGRAMMED = 'programmed',
  NOT_PROGRAMMED = ''
}
